import { useCheckoutSessionContext } from "@app/checkout/hooks";
import { CheckoutActivityLog } from "@app/common/services/activityLog/CheckoutActivityLog";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogHeightModes,
    DialogTitle,
    DialogVerticalPositions,
} from "@app/componentLibrary/ui/dialog";
import { Text } from "@app/componentLibrary/ui/text";
import { UtilsUrl } from "@hotelchamp/common";
import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";

import { useAppState, useBookingEngineStateContext, usePropertyContext } from "../hooks";
import { log } from "../services/log";

export const ErrorFallback = ({ error, resetErrorBoundary }: any) => {
    const [isOpen, setIsOpen] = useState(true);
    const { resetBooking } = useBookingEngineStateContext();
    const { activePropertyId } = usePropertyContext();
    const { globalState } = useAppState();
    const { state: checkoutSessionState, checkoutBookingValidation } = useCheckoutSessionContext();

    useEffect(() => {
        log.error("ErrorFallback", error, "isOpen", isOpen);

        // Log error to Sentry
        Sentry.captureException(error);

        log.error("Error caught by Error Boundary: ", error);

        new CheckoutActivityLog({
            message: "Error catched by error boundary: " + (error || "unknown error"),
            visitorId: globalState.visitorId,
            checkoutSessionId: checkoutSessionState.session_id,
            bookingId: checkoutSessionState.booking_id,
            channelBookingId: checkoutBookingValidation?.data?.reservedBooking?.reservation_id,
            propertyId: activePropertyId,
            metadata: {
                error: error?.toString() || "unknown error",
            },
        }).takeFromPreviousLog(["action"]);
        error();
    }, []);

    return (
        <Dialog
            open={isOpen}
            data-testid="error-fallback-dialog"
            onOpenChange={(open) => {
                if (!open) {
                    const nextUrl = UtilsUrl.setUrlParams(document.location.href, { p: "base", c: "search" });

                    resetBooking();
                    setIsOpen(false);

                    window.history.pushState({}, "", nextUrl);

                    setTimeout(resetErrorBoundary, 300);
                }
            }}
        >
            <DialogContent verticalPosition={DialogVerticalPositions.Middle} heightMode={DialogHeightModes.Fit}>
                <DialogHeader>
                    <DialogTitle>Something went wrong</DialogTitle>
                </DialogHeader>

                <div className="p-6 w-full max-h-fit">
                    <Text className="bg-white p-6">Something went wrong, please try again later!</Text>
                </div>
            </DialogContent>
        </Dialog>
    );
};
